import { render, staticRenderFns } from "./Login_phone.vue?vue&type=template&id=4f7749cd&"
import script from "./Login_phone.vue?vue&type=script&lang=js&"
export * from "./Login_phone.vue?vue&type=script&lang=js&"
import style0 from "./Login_phone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports